export const LEGACY_BASE_SIZE = 900;

export const resolvePlacementSide = (placement) => {
    if (placement === null || placement === undefined || placement === "") return null;
    const numeric = Number(placement);
    if (!Number.isFinite(numeric)) return null;
    if (numeric === 1) return "front";
    if (numeric === 0 || numeric === 2) return "back";
    return null;
};

export const coordToPct = (value, axisPx, base = LEGACY_BASE_SIZE) => {
    if (!Number.isFinite(axisPx) || axisPx <= 0) return null;
    if (!Number.isFinite(base) || base <= 0) return null;
    if (value === null || value === undefined) return null;

    const parseNumeric = (numeric) => {
        if (!Number.isFinite(numeric)) return null;
        if (Math.abs(numeric) <= 1) return numeric * 100;
        return (numeric / base) * 100;
    };

    if (typeof value === "string") {
        const raw = value.trim();
        if (!raw) return null;

        if (raw.endsWith("%")) {
            const pct = Number(raw.slice(0, -1).trim());
            return Number.isFinite(pct) ? pct : null;
        }

        if (raw.toLowerCase().endsWith("px")) {
            const px = Number(raw.slice(0, -2).trim());
            return Number.isFinite(px) ? (px / axisPx) * 100 : null;
        }

        return parseNumeric(Number(raw));
    }

    return parseNumeric(Number(value));
};
